import { render, staticRenderFns } from "./VTextAreaV2.vue?vue&type=template&id=5b4e602e&scoped=true&"
import script from "./VTextAreaV2.vue?vue&type=script&lang=js&"
export * from "./VTextAreaV2.vue?vue&type=script&lang=js&"
import style0 from "./VTextAreaV2.vue?vue&type=style&index=0&id=5b4e602e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e602e",
  null
  
)

export default component.exports